import React, { useId } from 'react';

// The chat's Send mark: a half pill with a dot. `light` is the quiet variant for secondary
// actions (a face's Open station).
export default function SendGlyph({ height = 32, light = false, label = 'Send' }) {
  const clip = `send-glyph-${useId().replace(/:/g, '')}`;
  const ink = light ? '#c3cedc' : '#4a6079';
  const dot = light ? '#ffffff' : '#d6dade';
  return (
    <svg role="img" aria-label={label} viewBox="471.54 205 130 130" fill="none"
         style={{ height: `${height}px`, display: 'block',
                  filter: light ? 'none' : 'drop-shadow(0 2px 4px rgba(0,0,0,0.35))' }}>
      <defs>
        <clipPath id={clip}>
          <rect x="480" y="205" width="130" height="130" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clip})`}>
        <path
          d="m370.56693 270.0c0 -32.641327 48.994873 -59.102356 109.433075 -59.102356c60.438232 0 109.433044 26.46103 109.433044 59.102356c0 32.641327 -48.994812 59.102356 -109.433044 59.102356c-60.4382 0 -109.433075 -26.46103 -109.433075 -59.102356z"
          fill={ink} stroke={ink} strokeWidth="7.296587926509186" strokeLinejoin="round" />
        <path
          d="m518.29724 269.82394c0 -13.733185 11.132935 -24.86615 24.86615 -24.86615c6.5949097 0 12.919678 2.6198273 17.583008 7.283127c4.66333 4.663315 7.283142 10.988113 7.283142 17.583023c0 13.733185 -11.132996 24.86615 -24.86615 24.86615c-13.733215 0 -24.86615 -11.132965 -24.86615 -24.86615z"
          fill={dot} stroke={ink} strokeWidth="7.296587926509186" strokeLinejoin="round" />
      </g>
    </svg>
  );
}
